export default "__VITE_ASSET__4dfc1a07__"